import { startLoading, stopLoading } from './PageAction';
import { formAPI, GetFormListDataParams } from '../../api/form/FormAPI';
import { newStringInstance, prettyDescribeError } from 'capture-entry/util/HelperErrors';

export const SET_FORM_LIST_FETCHING = 'SET_FORM_LIST_FETCHING';
function setFormListFetching(fetching) {
    return {
        type: SET_FORM_LIST_FETCHING,
        fetching,
    };
}
export const SET_FORM_LIST_SUCCESS = 'SET_FORM_LIST_SUCCESS';
function setFormListFetchSuccess() {
    return {
        type: SET_FORM_LIST_SUCCESS,
        lastModified: new Date().getTime(),
    };
}
export const SET_FORM_LIST_ERROR = 'SET_FORM_LIST_ERROR';
function setFormListFetchError(error: any) {
    return {
        type: SET_FORM_LIST_ERROR,
        error: error ? newStringInstance(prettyDescribeError(error)) : null,
    };
}
export const SET_FORM_LIST = 'SET_FORM_LIST';
function getFormList(templateId, formData) {
    const formList = formData.forms;
    return {
        type: SET_FORM_LIST,
        payload: {
            id: templateId,
            data: {
                formActionConfigurations: formData.form_action_configurations || [],
                headers: formData.headers || {},
                forms: formList || [],
                statuses: formData.forms.map(f => f.form_status) || [],
                lastModified: new Date().getTime(),
                perPage: formData.max_item_per_page,
                totalPages: formData.total_page,
                currentPage: typeof formData.current_page === 'string' ?  // temp TODO: can remove condition once api is fixed
                    parseInt(formData.current_page) : formData.current_page,
            },
        },
    };
}
export const SET_TEMPLATE_FORM = 'SET_TEMPLATE_FORM';
function setTemplateFormById({ formId, templateId, form }) {
    return {
        type: SET_TEMPLATE_FORM,
        payload: {
            id: formId,
            templateId,
            form,
        },
    };
}

function startFetching(dispatch) {
    dispatch(startLoading());
    dispatch(setFormListFetching(true));
}
function stopFetching(dispatch) {
    dispatch(setFormListFetching(false));
    dispatch(stopLoading());
}

export function actionGetFormList(templateId: number, getFormListParams: GetFormListDataParams, page?: number) {
    return async (dispatch: any) => {
        startFetching(dispatch);

        try {
            const { headers, forms, form_action_configurations,
                max_item_per_page, total_page, current_page,
            } =
                await formAPI.getFormList(templateId, getFormListParams, page);
            const formsWithHeaders = {
                headers,
                forms,
                form_action_configurations,
                max_item_per_page, total_page, current_page
            };
            dispatch(getFormList(templateId, formsWithHeaders));
            dispatch(setFormListFetchSuccess());
        } catch (e: any) {
            const desc = e.responseJSON?.status_desc;
            if (desc) {
                dispatch(setFormListFetchError(desc));
            }
        } finally {
            stopFetching(dispatch);
        }
    };
}

export function actionUpdateTemplateForm({ formId, templateId, uid, data }) {
    return async dispatch => {
        startFetching(dispatch);
        try {
            const { form } = await formAPI.callFormAction({
                formId,
                uid,
                data,
            });
            dispatch(setTemplateFormById({ formId, templateId, form }));
        } catch (e) {
            throw e;
        } finally {
            stopFetching(dispatch);
        }
    };
}
